import SportsLandingPage from './SportsLandingPage';
import { SportsLandingPageProps, SportsLandingPageValueProps } from './types';

export type { SportsLandingPageProps, SportsLandingPageValueProps };
export default SportsLandingPage;
